<template>
  <chip-group-field
    v-model="line"
    class="mb-3"
    column
    label="Quote Request Type"
    selected-class="bg-success"
    v-bind="lineValidation"
  >
    <template #chips>
      <v-chip
        v-for="{ title, value } in quoteRequestTypes"
        :key="title"
        :data-testid="`line-${title}`"
        :value="value"
        :text="title"
      />
    </template>
  </chip-group-field>
</template>

<script setup>
import { useQuoteRequestStore } from "@/stores/quote-request";
import { storeToRefs } from "pinia";
import useVuelidate from "@vuelidate/core";
import { computedValidation } from "@/util/helpers";
import { QUOTE_REQUEST_LINE } from "@/models/Quote";

const quoteRequest = useQuoteRequestStore();
const { line } = storeToRefs(quoteRequest);

const quoteRequestTypes = [
  { title: "Annuity", value: QUOTE_REQUEST_LINE.ANNUITY },
  { title: "Disability", value: QUOTE_REQUEST_LINE.DISABILITY },
  { title: "Life", value: QUOTE_REQUEST_LINE.LIFE },
  { title: "Long Term Care", value: QUOTE_REQUEST_LINE.LTC },
  { title: "Group", value: QUOTE_REQUEST_LINE.GROUP }
];

const v$ = useVuelidate(
  { line: { required: v => !!v } },
  { line },
  { $scope: "quote-request" }
);

const lineValidation = computedValidation(v$.value.line, [
  { key: "required", message: "Required" }
]);
</script>
